export default __webpack_public_path__ + "static/knotbreak-7fb9a9e9a0f64d1a34d91c2fa4de9710.png";